export default __webpack_public_path__ + "static/media/profilephoto.884e6975.png";